import { Pipe, PipeTransform } from "@angular/core";
import { log } from "@app2/logger";
import { TimeService } from "@app2/shared/services/time.service";

const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}\:\d{2}\:\d{2}(\.\d+)?Z$/;

@Pipe({
    name: "timestamp",
})
export class TimestampPipe implements PipeTransform {

    constructor(private readonly timeService: TimeService) {
    }

    transform(date: string) {
        return TimestampPipe.transformImpl(date, this.timeService);
    }

    public static transformImpl(date: number | date | Moment, timeSource: any) {
        const formatString = timeSource.formats.timestamp;

        if (date === null || date === undefined) {
            return "";
        } else if (moment.isMoment(date)) {
            // input is already a Moment, and just needs to be formatted.
            return timeSource.timeZoneMoment(date.valueOf()).format(formatString);
        } else if (typeof date === "number") {
            // input is assumed to be an epoch/unix timestamp
            return timeSource.timeZoneMoment(date).format(formatString);
        } else if (typeof date === "string" && isoDateRegex.test(date as string)) {
            // input is an ISO formatted datetime string ending in Z, parse it to local time
            // Moment will NOT parse non-offset timezones and convert them as expected.
            return timeSource.timeZoneMoment(date).format(formatString);
        }

        if (typeof date !== "string") {
            log.warn("Unknown date type", date);
        }

        // If the input's format is not recognized, return it as-is.
        return date;
    }
}
